export enum LocaleCode {
    de_DE = "de-DE",
    en_US = "en-US",
    es_ES = "es-ES",
    fr_FR = "fr-FR",
    it_IT = "it-IT",
    nl_NL = "nl-NL",
    pt_PT = "pt-PT"
}
